import { render, staticRenderFns } from "./FiguresPage.vue?vue&type=template&id=79a35771&"
import script from "./FiguresPage.vue?vue&type=script&lang=js&"
export * from "./FiguresPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports